<template>
  <vue-draggable-resizable
    class="draggableItem"
    drag-cancel=".dragCancel"
    >
    <div class="draggableItem__header searchInCode">
      <span class="draggableItem__title">Search in {{ label }} code</span>
      <a
        href="#"
        class="draggableItem__close dragCancel"
        @click.prevent="close"
        v-b-tooltip.hover
        title="close"
        >
        <icon name="remove" />
      </a>
    </div>
    <div class="draggableItem__body searchInCode__body">
      <b-form-group>
        <b-form-input
          v-model="searchKey"
          type="text"
          placeholder="Search key"
          class="dragCancel"
          @input="search"
          ref="searchInput"
          />
      </b-form-group>
      <div class="searchInCode__result">
        <h4
          v-if="!matches.length"
          class="searchInCode__notFound"
          >
          <i>Nothing found</i>
        </h4>
        <div
          v-else
          class="searchInCode__resultList"
          >
          <div
            v-for="(match, idx) in matches"
            :key="idx"
            class="searchInCode__resultItem"
            >
            <a
              href="#"
              @click.prevent="editCode(match.id, match.line)"
              >
              <span class="searchInCode__resultCoords">({{ match.line }}:{{ match.column }})</span>
              <span class="searchInCode__resultFileName">{{ match.file }}</span>
              <span class="searchInCode__resultString" v-html="match.string"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import eventBus from '@/helpers/event-bus'

let _ = window._

export default {
  props: ['type', 'code'],
  data () {
    return {
      searchKey: '',
      matches: []
    }
  },
  computed: {
    label () {
      let label

      switch (this.type) {
        case 'js': label = 'JavaScript'
          break
        case 'css': label = 'CSS'
          break
        case 'html': label = 'HTML'
      }

      return label
    }
  },
  methods: {
    close () {
      eventBus.$emit('hideSearchBar', this.type)
    },
    search: _.debounce(function () {
      this.matches = []
      if (this.searchKey.length < 2) return

      for (let key in this.code) {
        let splited = this.code[key].code.split('\n')
        for (let line in splited) {
          if (typeof splited[line] !== 'string') continue
          let column = (splited[line].toLowerCase()).indexOf(this.searchKey.toLowerCase())
          if (~column) {
            let match = {}
            match.file = this.code[key].name + '.' + this.type
            match.id = key
            match.string = splited[line].replace(new RegExp(this.searchKey, 'i'), (x) => {
              return '<strong>' + x + '</strong>'
            })
            match.line = parseInt(line, 10) + 1
            match.column = column
            this.matches.push(match)
          }
        }
      }
    }, 500),
    editCode (key, line) {
      this.$store.commit('editCustomCode', {
        key,
        line,
        insert: true
      })
    }
  },
  created () {
    setTimeout(() => {
      this.$refs.searchInput.focus()
    })
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.searchInCode {
  &__body {
    display: flex;
    flex-direction: column;
  }
  &__result {
    flex-grow: 1;
    overflow: auto;
    &Item {
      border-bottom: 1px solid $borderColor1;
      &:first-child {
        border-top: 1px solid $borderColor1;
      }
      strong {
        background: yellow;
        color: red;
      }
    }
    a {
      display: block;
      padding: 3px 0;
    }
    a:hover {
      background: #f4f8fb;
    }
    &String {
      display: block;
      white-space: nowrap;
    }
  }
  &__notFound {
    font-weight: bold;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomCodeSearch.vue